<template>
	<div class="bottom u-flex u-row-around">
		<div>
			<div style="width:190px;height:90px;background-color: #000;">
				<img src="../assets/logo.png" style="width: 100%;height: 100%;" alt="">
			</div>
			<div style="font-size: 14px;color: #000;margin: 34px 0 16px;">Copyright ©2020 北京XX</div>
			<div style="font-size: 14px;color: #000;">京ICP备2020047067号-1</div>
		</div>
		<!-- <div style="line-height:30px">
			<div style="font-size: 20px;color: #000;">产品与展示</div>
			<div style="font-size: 14px;color: #000;" v-for="(item,index) in datalist" :key="index" @click="toinfo(item)">{{item.name}}</div>
		</div> -->
		<div style="line-height:30px">
			<div style="font-size: 20px;color: #000;">联系我们</div>
			<div style="font-size: 14px;color: #000;"><i class="el-icon-phone" style="margin-right:5px"></i>400-888-666</div>
			<div style="font-size: 14px;color: #000;"><i class="el-icon-s-promotion" style="margin-right:5px"></i>北京市海淀区学院南路15号16号楼一层1</div>
			<!-- <div style="font-size: 14px;width: 74px;height: 74px;background-color: #000;"></div> -->

		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				datalist: []
			};
		},
		created() {
			this.getlist()
		},
		methods:{
			getlist() {
				this.$http({
					url: '/api/Product/product'
				}).then(res => {
					this.datalist = res.data
				})
			},
			toinfo(item){
				this.$router.push({
					path:"/Database",
					query:{
						active:`2-${item.id}`
					}
				})
			}
		}
	}
</script>

<style>
	.bottom {
		padding: 30px 0;
		width: 100%;
		background-color: #fff;
		color: #fff;

	}
</style>
